import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';

import { Logger } from '@utils/logger';
import {
  SubscriptionsParams,
  SubscriptionToggleOption,
} from '@marketing/subscriptions-manage/subscription-manage.interface';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@shared/translate/translate.service';

/**
 * Logger
 */
const logger = Logger.getLogger('SubscriptionsManageComponent');

const enum SubscriptionToggleView {
  BASIC = 'basic-view',
  ADVANCED = 'advanced-view',
}

@Component({
  selector: 'ft-subscriptions-manage',
  templateUrl: './subscriptions-manage.component.html',
  styleUrls: ['./subscriptions-manage.component.scss'],
})
export class SubscriptionsManageComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy {
  public subscriptionsParams: SubscriptionsParams;
  public toggleButtons: SubscriptionToggleOption[];

  constructor(
    @Inject(DOCUMENT) readonly docRef: Document,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.toggleButtons = [
      {
        active: false,
        text: this.translateService.instant(
          `subscriptions.${SubscriptionToggleView.BASIC}`
        ),
        value: SubscriptionToggleView.BASIC,
      },
      {
        active: false,
        text: this.translateService.instant(
          `subscriptions.${SubscriptionToggleView.ADVANCED}`
        ),
        value: SubscriptionToggleView.ADVANCED,
      },
    ];
    this.subscriptionsParams = this.component.getParameters();
    if (this.subscriptionsParams?.sectionType === 'products-v2') {
      this.toggleButtons[0].active = true;
    } else {
      this.toggleButtons[1].active = true;
    }
    if (this.subscriptionsParams?.scale !== 'no' && !this.page.isPreview()) {
      const scale = parseFloat(this.subscriptionsParams.scale) / 100;
      // Using Zoom style as it affects the layout size of the element.
      // It is better for scaling in the MSD iFrame.
      this.docRef.body.style.zoom = `${scale}`;
      // Zoom is not supported in Firefox. Need to use -moz-transform.
      this.docRef.body.style['-moz-transform'] = `scale(${scale})`;
      this.docRef.body.style['-moz-transform-origin'] = 'top';
    }
    logger.debug('Component initialised');
  }

  /**
   * when toggle option is clicked
   */
  public onToggleActive(selectedOption: SubscriptionToggleOption) {
    if (selectedOption.value === SubscriptionToggleView.BASIC) {
      this.subscriptionsParams.sectionType = 'products-v2';
    } else {
      this.subscriptionsParams.sectionType = 'products-v3';
    }
  }

  ngOnDestroy(): void {
    this.docRef.body.style.zoom = null;
    this.docRef.body.style['-moz-transform'] = null;
    this.docRef.body.style['-moz-transform-origin'] = null;
  }
}
